import {
  MenuLayoutProps,
  BaseMenuItem,
  BottomMenuEnum,
} from './MenuLayout.props'
import {
  FieldTypeFactory,
  ComponentTypeFactory,
} from '@sentecacommerce-theme/base'
import { FooterTypeData } from '../Footer/footer.type'

const base = {
  menuName: FieldTypeFactory.text({ required: true }),
  menuUrl: FieldTypeFactory.text({ required: true }),
  menuDescription: FieldTypeFactory.text({ required: false }),
  menuImage: FieldTypeFactory.image({ required: false }),
  menuImageLabel: FieldTypeFactory.text({ required: false }),
  menuImageLink: FieldTypeFactory.text({ required: false }),
  menuLabel: FieldTypeFactory.text({ required: false }),
  menuClass: FieldTypeFactory.text({ required: false }),
}

const columns = {
  col1: FieldTypeFactory.list({
    of: {
      menuName: FieldTypeFactory.text({ required: true }),
      menuUrl: FieldTypeFactory.text({ required: true }),
      menuDescription: FieldTypeFactory.text({ required: false }),
      menuClass: FieldTypeFactory.text({ required: false }),
    },
  }),
  col2: FieldTypeFactory.list({
    of: {
      menuName: FieldTypeFactory.text({ required: true }),
      menuUrl: FieldTypeFactory.text({ required: true }),
      menuDescription: FieldTypeFactory.text({ required: false }),
      menuClass: FieldTypeFactory.text({ required: false }),
    },
  }),
}

const SearchBoxLabels = {
  recentSearchesLabel: FieldTypeFactory.text({ required: true }),
  popularSearchesLabel: FieldTypeFactory.text({ required: true }),
  suggestedBrandsLabel: FieldTypeFactory.text({ required: true }),
  suggestedCategoriesLabel: FieldTypeFactory.text({ required: true }),
  productsLabel: FieldTypeFactory.text({ required: true }),
  promoOffersLabel: FieldTypeFactory.text({ required: true }),
  blogLabel: FieldTypeFactory.text({ required: true }),
  blog: {
    blogTitle: FieldTypeFactory.text({ required: true }),
    image: FieldTypeFactory.image({ required: true }),
    description: FieldTypeFactory.text({ required: true }),
    url: FieldTypeFactory.text({ required: true }),
  },
}

const SearchBox = {
  labels: SearchBoxLabels,
  labelsColor: FieldTypeFactory.text({ required: true }),
  textColor: FieldTypeFactory.text({ required: true }),
  priceColor: FieldTypeFactory.text({ required: false }),
  backgroundColor: FieldTypeFactory.text({ required: false }),
  bottomMenu: FieldTypeFactory.enum({
    required: true,
    of: [
      { label: 'No Bottom menu', value: BottomMenuEnum.empty },
      { label: 'Additional products', value: BottomMenuEnum.moreProducts },
      { label: 'Promotional products', value: BottomMenuEnum.promo },
    ],
    defaultValue: BottomMenuEnum.empty,
  }),
  withRecent: FieldTypeFactory.boolean({ required: true }),
  withSuggested: FieldTypeFactory.boolean({ required: true }),
}

export const MenuLayoutType = ComponentTypeFactory.create<MenuLayoutProps>(
  'MenuLayout',
  {
    menuItems: FieldTypeFactory.tree<BaseMenuItem>({
      of: {
        ...base,
        columns: columns,
        disabled: FieldTypeFactory.boolean({
          required: true,
          defaultValue: false,
        }),
        nodes: [base],
      },
    }),
    footer: FooterTypeData,
    background: FieldTypeFactory.text({ required: false }),
    suggestedMenus: FieldTypeFactory.list({
      of: {
        menuName: FieldTypeFactory.text({ required: true }),
        items: FieldTypeFactory.list({
          of: {
            label: FieldTypeFactory.text({ required: true }),
            url: FieldTypeFactory.text({ required: true }),
          },
        }),
      },
    }),
    labels: {
      productsLabel: FieldTypeFactory.text({ required: true }),
      noResultsFound: FieldTypeFactory.text({ required: true }),
      brandsLabel: FieldTypeFactory.text({ required: true }),
      categoriesLabel: FieldTypeFactory.text({ required: true }),
      seeAllLabel: FieldTypeFactory.text({ required: true }),
      search: FieldTypeFactory.text({ required: true }),
      me: FieldTypeFactory.text({ required: true }),
      free: FieldTypeFactory.text({ required: true }),
      overPrice: FieldTypeFactory.text({ required: true }),
      ariaLabelsAltsPlaceholders: {
        search: FieldTypeFactory.text({ required: true }),
        location: FieldTypeFactory.text({ required: true }),
        favorites: FieldTypeFactory.text({ required: true }),
        basket: FieldTypeFactory.text({ required: true }),
        logo: FieldTypeFactory.text({ required: true }),
        mainBanner: FieldTypeFactory.text({ required: true }),
      },
      categories: FieldTypeFactory.text({ required: true }),
      brandsAZ: FieldTypeFactory.text({ required: true }),
      myAccount: FieldTypeFactory.text({ required: true }),
      favorites: FieldTypeFactory.text({ required: true }),
      basket: FieldTypeFactory.text({ required: true }),
      info: FieldTypeFactory.text({ required: true }),
      stores: FieldTypeFactory.text({ required: true }),
      phoneNumber: FieldTypeFactory.text({ required: true }),
    },
    searchBox: SearchBox,
    topStrip: FieldTypeFactory.list({
      of: {
        value: FieldTypeFactory.text({ required: true }),
        link: FieldTypeFactory.text({ required: true }),
      },
    }),
  }
)
